import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseListItem from '../../ListItem'

export const Icon = styled.span``

export const Label = styled.span``

export const ListActionItem = styled(BaseListItem)`
  color: #0e60c9;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background: #f1f5f9;

    ${Label} {
      color: #0b4fa5;
    }
  }
`
